export default __webpack_public_path__ + "static/media/slide202505.548e5bff.webp";